import React, { useState } from "react";
import { Link } from "react-router-dom";

import Card from "../../MyUI/Card/Card";
import hasPermission from "../../../assets/files/hasPermission";

const Profile = () => {
  const [panelOpen, setPanelOpen] = useState(true);

  const myProfilePath = "/myprofile";
  const [collapsed, setCollapsed] = useState(false);
        
    const toggleCard = () => {
        setCollapsed((prev) => !prev);
    };
  

  return (
    <Card title="Profile" collapsed={collapsed} toggleCard={toggleCard} showChevron={true}>
  
    <div className="d-flex justify-center mb-6 bg-surface-variant">
      <div className="md6">
        {/* Expansion Panel */}
        <div className="expansion-panels">
          <div className="expansion-panel">

            {/* Content */}
            {panelOpen && (
              <div >
                <div style={{
                      display: "flex",
                      //justifyContent: "center",
                      flexDirection: "column",  
                      alignItems: "center",
                      height: "100vh"   ,
                      gap: "12px"
                    }}>
                  <div>
                    <Link to={myProfilePath}>
                      <button className="mx-4 btn btn-green btn-xlarge">
                        My Profile
                      </button>
                    </Link>
                    </div>
                    <div>
                    <Link to="/tickets/1">
                      <button className="mx-4 btn btn-green btn-xlarge">
                        My Tickets{" "}
                        {hasPermission("view_profiles") && (
                          <span>(Admin)</span>
                        )}
                      </button>
                    </Link>

                    </div>
                    <div>

                    <Link to="/About">
                      <button className="mx-4 btn btn-green btn-xlarge">
                        About
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </Card>
  );
};

export default Profile;
